// (C) Copyright 2025 Hewlett Packard Enterprise Development LP
import PropTypes from 'prop-types'
import { useState } from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { isAuthzV2London } from '../../../../utils/feature-flag-utils'

import WorkspaceScopeSelection from './WorkspaceScopeSelection'
import CustomerScopeSelection from './CustomerScopeSelection'
import OneRoleAppWarningNotification from './OneRoleAppWarningNotification'

const MSPScopeSelection = ({
  handleSelection,
  scopeInfo,
  workspaceScopeError,
  customerWorkspaceScopeError,
  setApiError,
  isCCSRole = false,
  hasMSPOneRoleAppScope,
  hasCustomerOneRoleAppScope,
  setHasConflictingMSPOneRoleAppRA = () => {},
  hasConflictingOneRoleAppRA,
  hasConflictingMSPOneRoleAppRA,
  serviceName,
  roleAssignedLoading,
  loadingWhileCheckingFixedScopePerm,
  subject
}) => {
  const LDFlags = useFlags()
  const isV2London = isAuthzV2London(LDFlags)
  const [mspScopeSelected, setMSPScopeSelected] = useState(false)
  return (
    <>
      <WorkspaceScopeSelection
        handleSelection={handleSelection}
        scopeOption={scopeInfo?.scope}
        preselectScopeGroups={scopeInfo?.scopeGroupInstances}
        scopeError={workspaceScopeError}
        setApiError={setApiError}
        isCCSRole={isCCSRole}
        hasMSPOneRoleAppScope={hasMSPOneRoleAppScope}
        setHasConflictingMSPOneRoleAppRA={setHasConflictingMSPOneRoleAppRA}
        setMSPScopeSelected={setMSPScopeSelected}
      />
      {hasConflictingOneRoleAppRA &&
        isV2London &&
        hasConflictingMSPOneRoleAppRA &&
        !roleAssignedLoading &&
        !loadingWhileCheckingFixedScopePerm &&
        hasMSPOneRoleAppScope &&
        !hasCustomerOneRoleAppScope && (
          <OneRoleAppWarningNotification
            state={scopeInfo}
            serviceName={serviceName}
            subject={subject}
          />
        )}
      <CustomerScopeSelection
        handleSelection={handleSelection}
        preselectWorkspaceGroups={scopeInfo?.workspaceGroupInstances}
        scopeOption={scopeInfo?.customerWorkspaceScope}
        scopeError={customerWorkspaceScopeError}
        setApiError={setApiError}
        hasMSPOneRoleAppScope={hasMSPOneRoleAppScope}
        hasCustomerOneRoleAppScope={hasCustomerOneRoleAppScope}
        setHasConflictingMSPOneRoleAppRA={setHasConflictingMSPOneRoleAppRA}
        mspScopeSelected={mspScopeSelected}
      />
    </>
  )
}

MSPScopeSelection.propTypes = {
  handleSelection: PropTypes.func.isRequired,
  scopeInfo: PropTypes.object.isRequired,
  workspaceScopeError: PropTypes.object.isRequired,
  customerWorkspaceScopeError: PropTypes.object.isRequired,
  setApiError: PropTypes.func.isRequired,
  isCCSRole: PropTypes.bool.isRequired,
  hasMSPOneRoleAppScope: PropTypes.bool,
  hasCustomerOneRoleAppScope: PropTypes.bool,
  setHasConflictingMSPOneRoleAppRA: PropTypes.func,
  hasConflictingOneRoleAppRA: PropTypes.bool,
  hasConflictingMSPOneRoleAppRA: PropTypes.bool,
  roleAssignedLoading: PropTypes.bool,
  loadingWhileCheckingFixedScopePerm: PropTypes.bool,
  serviceName: PropTypes.string,
  subject: PropTypes.object
}

export default MSPScopeSelection
